var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { findFreePlanId } from 'app/domains/companies';
import { marketPlansQuery } from './query';
export const useGetMarketFreePlanId = () => {
    const [query, { error, data, loading }] = useLazyQuery(marketPlansQuery);
    const planId = findFreePlanId(data === null || data === void 0 ? void 0 : data.plans);
    const getMarketFreePlanId = (marketCode) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield query({ variables: { marketCode } });
        return findFreePlanId((_a = response.data) === null || _a === void 0 ? void 0 : _a.plans);
    });
    return { getMarketFreePlanId, loading, error, data: planId };
};
